<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refPurchaseGrid'
        :data-source='purchaseInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="거래처코드"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="excelFileName"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          :allowEditing='true'
          caption="마감처명"
          data-field="거래처코드"
          :visible='true'
        >
           <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="구매수량"
          data-field="구매수량"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>

        <DxColumn
          :allowEditing="true"
          caption="월구매금액"
          data-field="구매금액"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="정산금액"
          data-field="정산금액"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="마감금액"
          data-field="계산서금액"
          :visible='true'
          dataType="number"
          format='#,##0.0'
          :calculate-cell-value="calcTaxAmount"
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="거래처코드"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="구매수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="구매금액"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="정산금액"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계산서금액"
            display-format="{0}"
          />
        </DxSummary>
        <DxMasterDetail
          :enabled="true"
          template="purchaseReCalc"
        />
        <template #purchaseReCalc="{ data: item }">
          <PurchaseReCalcSubGrid :item=item :baseDate="baseDate" goodsType="외주품" @refresh-recalc-amount="onRefreshRecalcAmount"
          />
        </template>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <!-- <template #scrap-price-date>
          <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
            <b>  스크랩단가 : {{scrapPrice}}원</b>
          </div>
        </template> -->
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxMasterDetail,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup,
  DxSummary, DxTotalItem
} from 'devextreme-vue/data-grid'
import PurchaseReCalcSubGrid from './PurchaseReCalcSubGrid'

export default {
  name: 'DoKubSummary',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '외주품/하드웨어 정산'
        }
      ],
      excelFileName: null,
      selectedRow: null,
      purchaseInfoList: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      materialTypeLookup: null,
      itemTypeLookup: null,
      isExpandAll: false,
      selectedRowBefore: 'init',
      baseDate: null,
      customerLookup: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxMasterDetail,
    DxSummary,
    DxTotalItem,
    PurchaseReCalcSubGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.customerLookup = this.$store.getters.getCompanyInfo
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.init()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcTaxAmount (row) {
      return row.구매금액 + row.정산금액
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      for (let i = this.thisYear; i >= 2021; i--) {
        this.yearArray.push({ 'year': i })
      }
      this.thisMonth = AppLib.getLastMonth()
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          this.monthArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          this.monthArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.refreshPurchaseResult()
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshPurchaseResult()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.thisMonth = args.value
              this.refreshPurchaseResult()
            }
          }
        }
      )
    },
    async refreshPurchaseResult () {
      this.excelFileName = `${this.thisYear}-${this.thisMonth}월_외주품_하드웨어_정산`
      this.baseDate = {
        fromDate: `${this.thisYear}-${this.thisMonth}-01`,
        toDate: `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)} 23:59:59`
      }

      this.$_sp.runNoEncodeFindProc('spFindAllPurchaseByEndDateGbyCompany', this.baseDate)
        .then((data) => {
          if (this.purchaseInfoList === null) {
            setTimeout(() => {
              this.$refs.refPurchaseGrid.instance.refresh()
            }, 400)
          }
          this.purchaseInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // Detail subcell
    onRefreshRecalcAmount (recalcAmount) {
      this.selectedRow.정산금액 = recalcAmount
      this.$refs.refPurchaseGrid.instance.refresh()
    }
  }
}
</script>

<style lang="scss">
</style>
